/* eslint-disable camelcase */
import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import { client } from "@johnpaul/jp-api-client";

import { COMPONENTS_PAGE_SIZE, sortData } from "@companion-core/shared/app/Utils/componentHelper";
import {
  APIBlockItem,
  ComponentData,
  JPClientRequest,
} from "@companion-core/shared/app/Interfaces/API";

interface BlockItemQuery {
  id: string;
  lang: string;
  pageSize?: number;
  enabled?: boolean;
}

export const useBlockItems = ({
  id,
  lang,
  pageSize = COMPONENTS_PAGE_SIZE,
  enabled,
}: BlockItemQuery) => {
  return useQuery({
    queryKey: ["block-items", id, lang, pageSize],
    queryFn: () =>
      client.content.v2.blocks.getBlockItems(id, {
        components_lang: lang,
        components_page_size: pageSize,
      }),
    select: (data: JPClientRequest<APIBlockItem>) => sortData(data.data.results) as APIBlockItem[],
    enabled: enabled ?? true,
    gcTime: 0,
  });
};

interface BlockItemComponentQuery {
  id: string;
  lang: string;
  page?: number;
  pageSize?: number;
  enabled?: boolean;
  filterParams?: { [key: string]: string };
}

export interface Page {
  data?: {
    next?: boolean;
    results?: ComponentData[];
  };
}

export const useBlockItemComponents = ({
  id,
  lang,
  page,
  pageSize = COMPONENTS_PAGE_SIZE,
  enabled,
  filterParams,
}: BlockItemComponentQuery) => {
  return useInfiniteQuery({
    queryKey: ["block-item-components", pageSize, id, lang, filterParams],
    queryFn: ({ pageParam }) =>
      client.content.v2.blocks.getBlockItemComponents(id, {
        lang,
        page_size: pageSize,
        page: pageParam,
        ...filterParams,
      }),
    initialPageParam: page,
    getNextPageParam: (lastPage: Page, allPages: Page[]) =>
      lastPage?.data?.next ? allPages.length + 1 : undefined,
    enabled: enabled ?? true,
    gcTime: 0,
  });
};
